import PropTypes from "prop-types";

const dataUrlToFile = (img) => {
	let arr = img.split(","),
		mime = arr[0].match(/:(.*?);/)[1],
		bstr = atob(arr[1]),
		n = bstr.length,
		u8arr = new Uint8Array(n);

	while (n--) {
		u8arr[n] = bstr.charCodeAt(n);
	}

	const extension = mime?.split("/")[1] || "png";
	return new File([u8arr], `myImg.${extension}`, { type: mime });
};

PropTypes.propTypes = {
	img: PropTypes.string.isRequired,
};

export default dataUrlToFile;
